// extracted by mini-css-extract-plugin
export default {"columnRole":"User_columnRole__GxpIf","content-wrapper":"User_content-wrapper__vbjRI"};